import React from "react";
import "../../styles/ui/native-animations.scss";
import PropTypes from "prop-types";
import cn from "classnames";

const SplitText = ({ children, generalDuration = 0.8, generalDelay = 0, wordDelay = 0.1, ...rest }) => {
	const words = children.split(" ");

	return (
		<>
			{words.map((word, index) => {
				const isGradientWord = word.startsWith('%g%');
				let renderWord = word;

				if (isGradientWord) {
					renderWord = word.substring(3);
				}

				return (
					<span
						key={index}
						className="split-text"
					>
						<span
							className={cn(
								"split-text__word",
								"split-text__word--animated",
								isGradientWord && "gradient-text"
							)}
							{...rest}
							style={{
								"--word-duration": `${generalDuration}s`,
								"--word-delay": `${generalDelay + index * wordDelay}s`,
								...rest.style,
							}}
						>
							{renderWord + (index !== words.length - 1 ? "\u00A0" : "")}
						</span>
					</span>
				)
			})}
		</>
	);
}

SplitText.propTypes = {
	generalDuration: PropTypes.number,
	generalDelay: PropTypes.number,
	wordDelay: PropTypes.number
};

export default SplitText;
